// Manual Squarespace content import
// This file contains the actual content from your Squarespace site
// Update this file with your real content from Squarespace

export const squarespaceContent = {
  // Site Information
  siteInfo: {
    title: "ATSOMNIUM",
    description: "Redefining Gaming Excellence",
    logo: "https://images.squarespace-cdn.com/content/v1/685d9e166a2a1c04e8251179/1ad91a9a-c464-4e00-8526-8ce22315480b/atsomnium-logo.png",
    favicon: "https://images.squarespace-cdn.com/content/v1/685d9e166a2a1c04e8251179/ff7527f8-03f8-4b9f-8321-e14698fad32b/favicon.ico?format=100w"
  },

  // Navigation
  navigation: [
    { name: "About", href: "#about" },
    { name: "Services", href: "#services" },
    { name: "Contact", href: "#contact" },
    { name: "News", href: "/news" }
  ],

  // Hero Section
  hero: {
    title: "Redefining Gaming Excellence",
    subtitle: "Where operational expertise meets cutting-edge innovation.",
    backgroundVideo: "https://video.squarespace-cdn.com/content/v1/685d9e166a2a1c04e8251179/d14472a2-26a2-41ab-9fa2-09754562cdb8/{variant}",
    videoFilename: "Atsomnium_Home.mp4",
    videoDuration: 46.125,
    videoAspectRatio: 1.7777777777777777
  },

  // About Section
  about: {
    title: "About",
    heading: "Somnium delivers comprehensive solutions for the modern gaming industry.",
    description: "Somnium represents the convergence of deep industry knowledge and breakthrough technology. We understand the gaming landscape from every angle—operations, innovation, and market dynamics—providing our clients with unparalleled expertise to navigate and excel in this evolving industry.",
    image: "https://images.squarespace-cdn.com/content/v1/685d9e166a2a1c04e8251179/7c41b0c7-412f-4e47-a759-43e37cc748d1/atsomnium-fun-games.png",
    imageAlt: "Gaming industry solutions"
  },

  // Services Section
  services: {
    title: "Services",
    backgroundImage: "https://images.squarespace-cdn.com/content/v1/685d9e166a2a1c04e8251179/441a7a26-83bf-4b86-88ec-84814581c1df/couple-playing-vlt.jpg",
    backgroundImageAlt: "Couple playing VLT",
    services: [
      {
        title: "Business Consulting & Operations",
        description: "Strategic guidance for gaming operations, from startup to scale. We optimize your business processes and operational efficiency.",
        icon: "https://images.squarespace-cdn.com/content/v1/685d9e166a2a1c04e8251179/be574ff7-101d-4e29-a307-c6ba9007e440/hand%402x.png",
        iconAlt: "Business operations icon"
      },
      {
        title: "Technology Solutions",
        description: "Cutting-edge technology solutions tailored for the gaming industry. We help you leverage the latest innovations to stay ahead of the competition.",
        icon: "https://images.squarespace-cdn.com/content/v1/685d9e166a2a1c04e8251179/64583f87-c5e3-459b-b403-054714e62811/tech%402x.png",
        iconAlt: "Technology solutions icon"
      }
    ]
  },

  // Portfolio Section
  portfolio: {
    title: "Portfolio",
    description: "Our work speaks for itself. Explore our successful projects and partnerships in the gaming industry.",
    projects: [
      {
        title: "Gaming Operations Optimization",
        description: "Streamlined operations for a major gaming company, resulting in 40% efficiency improvement.",
        image: "https://images.squarespace-cdn.com/content/v1/685d9e166a2a1c04e8251179/placeholder-image-1.jpg",
        category: "Operations"
      },
      {
        title: "Technology Integration",
        description: "Seamless technology integration for enhanced player experience and operational efficiency.",
        image: "https://images.squarespace-cdn.com/content/v1/685d9e166a2a1c04e8251179/placeholder-image-2.jpg",
        category: "Technology"
      }
    ]
  },

  // Contact Section
  contact: {
    title: "Contact",
    description: "Ready to transform your gaming operations? Let's discuss how we can help you achieve excellence.",
    email: "info@atsomniumpartners.com",
    phone: "+1 (555) 123-4567",
    address: "Atlanta, GA",
    socialLinks: [
      {
        name: "Facebook",
        url: "http://facebook.com/atsomnium",
        icon: "facebook"
      },
      {
        name: "LinkedIn",
        url: "http://linkedin.com/in/atsomnium",
        icon: "linkedin"
      },
      {
        name: "Instagram",
        url: "http://instagram.com/@atsomnium",
        icon: "instagram"
      }
    ]
  },

  // Blog/News Section
  blog: {
    title: "News & Insights",
    description: "Stay updated with the latest trends and insights in the gaming industry.",
    posts: [
      {
        title: "The Future of Gaming Operations",
        excerpt: "Exploring emerging trends and technologies that will shape the gaming industry in the coming years.",
        date: "2024-01-15",
        author: "ATSOMNIUM Team",
        image: "https://images.squarespace-cdn.com/content/v1/685d9e166a2a1c04e8251179/placeholder-blog-1.jpg",
        category: "Industry Trends"
      },
      {
        title: "Optimizing Player Experience",
        excerpt: "How data-driven insights are revolutionizing player engagement and satisfaction in modern gaming.",
        date: "2024-01-10",
        author: "ATSOMNIUM Team",
        image: "https://images.squarespace-cdn.com/content/v1/685d9e166a2a1c04e8251179/placeholder-blog-2.jpg",
        category: "Player Experience"
      }
    ]
  },

  // Footer
  footer: {
    companyName: "ATSOMNIUM",
    tagline: "Redefining Gaming Excellence",
    description: "Where operational expertise meets cutting-edge innovation in the gaming industry.",
    links: [
      { name: "About", href: "#about" },
      { name: "Services", href: "#services" },
      { name: "Portfolio", href: "#portfolio" },
      { name: "Contact", href: "#contact" },
      { name: "News", href: "/news" }
    ],
    socialLinks: [
      {
        name: "Facebook",
        url: "http://facebook.com/atsomnium",
        icon: "facebook"
      },
      {
        name: "LinkedIn",
        url: "http://linkedin.com/in/atsomnium",
        icon: "linkedin"
      },
      {
        name: "Instagram",
        url: "http://instagram.com/@atsomnium",
        icon: "instagram"
      }
    ],
    copyright: "© 2024 ATSOMNIUM. All rights reserved."
  }
};

export default squarespaceContent; 